import { firstVisible, whenElementVisible, escapeHtml, accentedHtml, dropStaleHighlights } from './helpers';

// Opens each About Me tab in turn and explains what is inside it. Copy and order come from
// Tours::AboutMeIntro; the tab the visitor arrived on is put back on the way out. Mounted manually by
// about_me/index, so it only runs from the page title's "?".

const TAB_SELECTOR = '.tab-btn';
const tabSelector = (slug) => `${TAB_SELECTOR}[data-persistent-tabs-tab-param="${slug}"]`;

export default {
  mount({ start, payload, element }) {
    const steps = payload.steps || [];
    if (!steps.length) return undefined;

    const cleanups = [];

    // Every step clicks its tab, and persistent_tabs_controller treats a programmatic click as a
    // replaceState — so walking the tabs rewrites the URL without filling the back button.
    const tabButton = (slug) => firstVisible(tabSelector(slug), element);

    // /about_me/all has no button of its own, so a visitor who typed that URL is left on the last tab
    // the tour opened rather than back on the combined view.
    let arrivedOn;
    const restoreTab = () => tabButton(arrivedOn)?.click();

    const stepFor = (step) => ({
      // A function, not a node: the tour re-resolves it after the clicks below have moved the page.
      element: () => tabButton(step.slug),
      popover: {
        title: escapeHtml(step.title),
        description: accentedHtml(step.description),
        side: 'bottom',
        align: 'start',
      },
      onHighlightStarted: (target) => {
        dropStaleHighlights(target);
        tabButton(step.slug)?.click();
      },
    });

    const begin = () => {
      const present = steps.filter(({ slug }) => tabButton(slug));
      if (!present.length) return;

      arrivedOn = element.querySelector(`${TAB_SELECTOR}.active`)?.dataset.persistentTabsTabParam;
      start({ steps: present.map(stepFor), onDestroyed: restoreTab });
    };

    cleanups.push(whenElementVisible(steps.map(({ slug }) => tabSelector(slug)).join(', '), begin, { within: element }));

    return () => cleanups.forEach((cleanup) => cleanup());
  },
};
